import React, { useState } from 'react';

import './PhotoModalStyles.css'

const PhotoModal = ({ currentPhoto, directory, closeIt }) => {
  const { name, description, application, link, index } = currentPhoto;

  const [viewImage, viewingImage] = useState(true)
  const [viewImageDescription, viewingImageDescription] = useState(false)
  const [viewMaxImage, viewingMaxImage] = useState(false)

  // const closePhoto = () => {
  //   const photoModalImage = document.getElementById('Photo-Modal-Image')
  //   photoModalImage.className = 'PhotoModal-Section-Position PhotoModal-Photo-Section-Dimensions-Closed'
  //   setTimeout(() => {
  //     viewingImage(!viewImage)
  //   }, 300)
  // }

  const imageInfo = () => {
    const photoModalImage = document.getElementById('Photo-Modal-Image')
    if (viewImage === true && viewImageDescription === false) {
      photoModalImage.className = 'PhotoModal-Section-Position PhotoModal-Photo-Section-Dimensions-Closed-Fade'
      setTimeout(() => {
        viewingImage(!viewImage)
        viewingImageDescription(!viewImageDescription)
      }, 300)
    } else {
      const photoModalImage = document.getElementById('Photo-Modal-Image')
      if (viewImage === false && viewImageDescription === true)
        photoModalImage.className = 'PhotoModal-Section-Position PhotoModal-Description-Section-Dimensions-Closed-Fade'
      setTimeout(() => {
        viewingImageDescription(!viewImageDescription)
        viewingImage(!viewImage)
      }, 300)
    }
  }

  const showMaxImage = () => {
    const maxImage = document.getElementById('Photo-Modal-Max-Image')
    if (viewMaxImage === false) {
      
      viewingMaxImage(!viewMaxImage)
    } else {
      maxImage.className = 'PhotoModal-Section-Position PhotoModal-Max-Photo-Section-Dimensions-Closed'
      setTimeout(() => {
        viewingMaxImage(!viewMaxImage)
      }, 285);
    }
   
  }

  return (

    <section id='Photo-Modal'>

      {viewImage &&
        (
          <div id="Photo-Modal-Image" className='PhotoModal-Section-Position PhotoModal-Photo-Section-Dimensions-Opened'>
            <div className='Close-PhotoModal-Area' onClick={closeIt}></div>
            <img
              id='PhotoModal-Image'
              src={require(`../../../../assets/images/${directory}/1440/${index}.jpg`)}
              alt="current category"
              className='PhotoModal-Image'
              onClick={imageInfo}>
            </img>
            <div className='Close-PhotoModal-Area' onClick={closeIt}></div>
          </div>
        )}


      {viewImageDescription &&
        (
          <div id="Photo-Modal-Image" className='PhotoModal-Section-Position PhotoModal-Description-Section-Dimensions-Opened'>
            <div className='Close-PhotoModal-Area' onClick={closeIt}></div>
            <div className='PhotoModal-Photo-Description-Animations-Opened'>
              {application ? (
                <a href={link} target="_blank" rel="noopener noreferrer">
                  <h2>Checkout {name}</h2>
                </a>
              ) : (
                <h2 onClick={showMaxImage}>Checkout {name}</h2>
              )}

              <br></br>
              <h3 onClick={imageInfo}>{description}</h3>
            </div>
            <div className='CloseArea' onClick={imageInfo}></div>
            <div className='Close-PhotoModal-Area' onClick={closeIt}></div>
          </div>
        )}

      {viewMaxImage &&
        (
          <div id="Photo-Modal-Max-Image" className='PhotoModal-Section-Position PhotoModal-Max-Photo-Section-Dimensions-Opened'>
            <img
              src={require(`../../../../assets/images/${directory}/large-size/${index}.jpg`)}
              alt="current category"
              className='Photo-Modal-Max-View'
              onClick={showMaxImage}>
            </img>
          </div>
        )}
    </section>

  );
};

export default PhotoModal;
